import React from "react";

/* White flowers, drawn as line art.

   A wedding site wants florals, and a photograph of peonies is the wrong tool
   for that: it fixes a season, a colour and a mood, and it weighs half a
   megabyte. A few strokes of ivory and sage do the job at any size, in both
   themes, and cost nothing to load. Everything below is a single SVG so a
   corner can be flipped with one transform. */

const Sprig = () => (
  <g fill="none" strokeLinecap="round" strokeLinejoin="round">
    {/* main stem */}
    <path d="M20 300 C 60 220, 90 170, 150 120 S 260 60, 320 30" stroke="var(--sage)" strokeWidth="1.6" />
    {/* leaves along the stem */}
    {[
      [70, 235, -30],
      [105, 190, 25],
      [140, 150, -35],
      [185, 110, 20],
      [230, 78, -30],
      [275, 52, 22],
    ].map(([x, y, rot], i) => (
      <path
        key={i}
        d="M0 0 C 14 -12, 34 -12, 46 0 C 34 12, 14 12, 0 0 Z"
        transform={`translate(${x} ${y}) rotate(${rot})`}
        stroke="var(--sage)"
        strokeWidth="1.2"
        fill="rgba(126,155,139,0.10)"
      />
    ))}
    {/* peony */}
    <g transform="translate(150 118)">
      {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => (
        <path
          key={a}
          d="M0 0 C 10 -18, 26 -22, 30 -8 C 32 4, 18 10, 0 0 Z"
          transform={`rotate(${a})`}
          stroke="var(--gild)"
          strokeWidth="0.9"
          fill="rgba(255,255,255,0.92)"
        />
      ))}
      {[20, 65, 110, 155, 200, 245, 290, 335].map((a) => (
        <path
          key={`i${a}`}
          d="M0 0 C 6 -11, 16 -13, 18 -5 C 19 2, 11 6, 0 0 Z"
          transform={`rotate(${a})`}
          stroke="var(--gild)"
          strokeWidth="0.8"
          fill="rgba(255,255,255,0.96)"
        />
      ))}
      <circle r="3.2" fill="var(--gild)" opacity="0.7" />
    </g>
    {/* a smaller bloom further up */}
    <g transform="translate(262 62) scale(0.55)">
      {[0, 60, 120, 180, 240, 300].map((a) => (
        <path
          key={a}
          d="M0 0 C 10 -18, 26 -22, 30 -8 C 32 4, 18 10, 0 0 Z"
          transform={`rotate(${a})`}
          stroke="var(--gild)"
          strokeWidth="1.3"
          fill="rgba(255,255,255,0.92)"
        />
      ))}
      <circle r="4" fill="var(--gild)" opacity="0.7" />
    </g>
    {/* buds */}
    <path d="M300 42 c 6 -14, 14 -18, 20 -12 c 2 8, -6 16, -20 12 z" stroke="var(--sage)" strokeWidth="1" fill="rgba(255,255,255,0.9)" />
    <path d="M240 96 c 5 -12, 12 -15, 17 -10 c 2 7, -5 14, -17 10 z" stroke="var(--sage)" strokeWidth="1" fill="rgba(255,255,255,0.9)" />
  </g>
);

const TRANSFORMS = {
  "top-left": "scale(-1 1) translate(-340 0)",
  "top-right": "",
  "bottom-left": "scale(-1 -1) translate(-340 -320)",
  "bottom-right": "scale(1 -1) translate(0 -320)",
};

const POSITIONS = {
  "top-left": "left-0 top-0",
  "top-right": "right-0 top-0",
  "bottom-left": "bottom-0 left-0",
  "bottom-right": "bottom-0 right-0",
};

/** One floral sprig pinned to a corner of a `relative` parent. */
export const Florals = ({ corner = "top-right", size = 260, className = "" }) => (
  <svg
    viewBox="0 0 340 320"
    width={size}
    height={Math.round((size * 320) / 340)}
    aria-hidden
    className={`pointer-events-none absolute ${POSITIONS[corner]} ${className}`}
    style={{ zIndex: 0 }}
  >
    <g transform={TRANSFORMS[corner]}>
      <Sprig />
    </g>
  </svg>
);

/** A single bloom, inline — for a divider or a heading. */
export const Bloom = ({ size = 28, className = "" }) => (
  <svg viewBox="-20 -20 40 40" width={size} height={size} aria-hidden className={className}>
    {[0, 60, 120, 180, 240, 300].map((a) => (
      <path
        key={a}
        d="M0 0 C 6 -11, 16 -13, 18 -5 C 19 2, 11 6, 0 0 Z"
        transform={`rotate(${a})`}
        stroke="var(--gild)"
        strokeWidth="0.9"
        fill="rgba(255,255,255,0.95)"
      />
    ))}
    <circle r="2.4" fill="var(--gild)" opacity="0.75" />
  </svg>
);

export default Florals;
